// extracted by mini-css-extract-plugin
export default {"settings":"Setting_settings__uPbBW"};